/* eslint-disable */
import React, { useState, useMemo, useEffect } from 'react';
import useQlikApp from 'hooks/useQlikApp';
import PropTypes from 'prop-types';
import AppContext from './AppContext';

import { Switch, Route, Link, withRouter } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { setTeams } from '../redux/features/teams/teamsSlice';
import { setMatchups } from '../redux/features/matchups/matchupsSlice';

/* Qlik */
import useQlikSessionObject from 'hooks/useQlikSessionObject';
import teamQProp from 'config/hypercubeDefs/teamQProp';
import matchupQProp from 'config/hypercubeDefs/matchupQProp';

/* Styles */
import injectSheet from 'react-jss';

/* Components */
import CreateBracket from './CreateBracket';
import HistoricalAnalysis from './HistoricalAnalysis';
import { faListSquares } from '@fortawesome/free-solid-svg-icons';


const styles = theme => ({
  '@global': theme['@global'],
  '@keyframes bounce': {
    '0%, 20%, 50%, 80%, 100%': {
      transform: 'translateY(0)'
    },
    '40%': {
      transform: 'translateY(-30px)'
    },
    '60%': {
      transform: 'translateY(-15px)'
    },
  },
  loadingLogo: {
    position: 'absolute',
    width: '60px',
    height: '60px',
    left: 'calc(50% - 30px)',
    top: 'calc(50% - 30px)',
  },
  loadingLogoImg: {
    width: '100%',
    height: 'auto',
    animation: '$bounce 2s ease infinite'
  },
  loadingLogoQlik: {
    width: '86px',
    height: 'auto',
    position: 'absolute',
    bottom: '10px',
    left: 'calc(50% - 50px)',
  }
});


const App = ({ classes }) => {

  const [loading, setLoading] = useState(true);
  const [showIntro, setShowIntro] = useState(true);
  const [showHow, setShowHow] = useState(false);

  const dispatch = useDispatch();

  const qlikApp = useQlikApp();
  
  // Get Teams
  const qTeamData = useQlikSessionObject({
    app: qlikApp,
    properties: teamQProp
  });

  const teams = useMemo(() => {
    if (!qTeamData.layout) return [];
    let qlikData = [];
    if (qTeamData.layout.qHyperCube.qError) {
      qlikData = [];
    } else {
        qlikData = qTeamData.layout.qHyperCube.qDataPages[0].qMatrix.map((row) => ({
        id: row[0].qText,
        qElemNumber: row[0].qElemNumber,
        name: row[1].qText,
        group: row[2].qText,
        elorank: row[3].qText,
        fifarank: row[4].qText,
        won: row[5].qText,
        lost: row[6].qText,
        drawn: row[7].qText,
        goalsscored: row[8].qText,
        goalsreceived: row[9].qText,
        elointournament: row[10].qText,
        fifaintournament: row[11].qText,
        wc: row[12].qText,
      }));
    }
    return qlikData;
  }, [qTeamData.layout]);

  // Dispatch Set Teams
  useEffect(() => {
    if(teams.length) {
      dispatch(setTeams(teams));
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [teams]);

  // Get Matchups
  const qMatchupData = useQlikSessionObject({
    app: qlikApp,
    properties: matchupQProp
  });

  const matchups = useMemo(() => {
    if (!qMatchupData.layout) return [];
    let qlikDataMatchups = [];
    if (qMatchupData.layout.qHyperCube.qError) {
      qlikDataMatchups = [];
    } else {
      qlikDataMatchups = qMatchupData.layout.qHyperCube.qDataPages[0].qMatrix.map((row) => ({
        id: `${row[0].qText}${row[1].qText}`,
        chances: [row[2].qNum, row[3].qNum],
      }));
    }
    return qlikDataMatchups;
  }, [qMatchupData.layout]);


  // Dispatch Set Teams
  useEffect(() => {
    if(matchups.length) {
      dispatch(setMatchups(matchups));
    }
  }, [matchups]);

  const handleShowIntro = () => {
    setShowIntro(false);
    setShowHow(false);
  }
  const handleShowHow = () => {
    setShowHow(true);
  }

  return (
    <AppContext.Provider value={qlikApp}>
      <div>
         {
          loading ? 
          ( 
            <div>
              <div className={classes.loadingLogo}>
                <img src="assets/images/fifa-logo-alt.svg" alt="Loading" className={classes.loadingLogoImg} />
              </div> 
              <img src="assets/images/qlik-color.png" alt="Loading" className={classes.loadingLogoQlik} />
            </div>
          ) :
          ( <div>
            <Switch>
              <Route path="/historical-analysis/:view?" exact component={ (props) => <HistoricalAnalysis {...props} />} />
              <Route path="/:stage?/:bracketSection?" exact component={ (props) => <CreateBracket {...props} showIntro={showIntro} handleShowIntro={handleShowIntro} showHow={showHow} handleShowHow={handleShowHow} />} />
            </Switch>
          </div> )
         }
      </div>
    </AppContext.Provider>
  );
};

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(injectSheet(styles)(App));
